import Levenshtein from 'fast-levenshtein';

/**
 * Compare two strings and return a score between 0 and 1.
 * 0: strings are identical
 * 1: strings are different
 */
export function compareStrings(original: string, updated: string): number {
    if (original === updated) {
        return 0;
    }

    const maxLength = Math.max(original.length, updated.length);
    return Levenshtein.get(original, updated) / maxLength;
}
